<template>
    <div name="my" class="my" v-if="step === 0">
        <img class="image" src="../../assets/showcase/xi/my/0/1.png" />
        <img class="image" src="../../assets/showcase/xi/my/0/2.png" @click="stepChange(1)" />
        <div class="wrapper">
            <img class="image" src="../../assets/showcase/xi/my/0/3.png" />
            <div class="button1" @click="stepChange(2)">

            </div>
            <div class="button2" @click="stepChange(4)">
                
            </div>
            <div class="button3" @click="stepChange(6)">
                
            </div>
        </div>
        
        <img class="image" src="../../assets/showcase/xi/my/0/4.png" style="margin-top: -6px;"/>
        <img class="image" src="../../assets/showcase/xi/my/0/5.png" @click="stepChange(8)"/>
        <img class="image" src="../../assets/showcase/xi/my/0/6.png" @click="goHistory"/>
        <img class="image" src="../../assets/showcase/xi/my/0/7.png" @click="goHistoryHospital"/>
        <img class="image" src="../../assets/showcase/xi/my/0/8.png" />
    </div>
    <div name="my" class="my" v-else-if="step === 1">
        <img class="image" src="../../assets/showcase/xi/my/1/1.png" @click="stepChange(0)"/>
        <img class="image" src="../../assets/showcase/xi/my/1/2.png" />
        <img class="image" src="../../assets/showcase/xi/my/1/3.png" @click="stepChange(0)"/>
        <img class="image" src="../../assets/showcase/xi/my/1/4.png" />

    </div>
    <div name="my" class="my" v-else-if="step === 2">
    <!-- 가족관리 -->
        <img class="image" src="../../assets/showcase/xi/my/2/1.png" @click="stepChange(0)"/>
        <img class="image" src="../../assets/showcase/xi/my/2/2.png" />
        <img class="image" src="../../assets/showcase/xi/my/2/3.png" @click="stepChange(3)"/>
        <img class="image" src="../../assets/showcase/xi/my/2/4.png" />
    </div>
    <div name="my" class="my" v-else-if="step === 3">
    <!-- 가족관리 -->
        <img class="image" src="../../assets/showcase/xi/my/3/1.png" @click="stepChange(2)"/>
        <img class="image" src="../../assets/showcase/xi/my/3/2.png" />
    </div>
    <div name="my" class="my" v-else-if="step === 4">
        <!-- 배송지관리 -->
        <img class="image" src="../../assets/showcase/xi/my/4/1.png" @click="stepChange(0)"/>
        <img class="image" src="../../assets/showcase/xi/my/4/2.png" />
        <img class="image" src="../../assets/showcase/xi/my/4/3.png" @click="stepChange(5)"/>
        <img class="image" src="../../assets/showcase/xi/my/4/4.png" />
    </div>
    <div name="my" class="my" v-else-if="step === 5">
        <!-- 배송지관리 -->
        <img class="image" src="../../assets/showcase/xi/my/5/1.png" @click="stepChange(4)"/>
        <img class="image bottom2" src="../../assets/showcase/xi/my/5/2.png" @click="stepChange(4)"/>
    </div>
    <div name="my" class="my" v-else-if="step === 6">
        <!-- 결제관리 -->
        <img class="image" src="../../assets/showcase/xi/my/6/1.png" @click="stepChange(0)"/>
        <img class="image" src="../../assets/showcase/xi/my/6/2.png"/>
        <img class="image" src="../../assets/showcase/xi/my/6/3.png" @click="stepChange(7)"/>
        <img class="image" src="../../assets/showcase/xi/my/6/4.png"/>
    </div>
    <div name="my" class="my" v-else-if="step === 7">
        <!-- 결제관리 -->
        <img class="image" src="../../assets/showcase/xi/my/7/1.png" @click="stepChange(6)"/>
        <img class="image bottom" src="../../assets/showcase/xi/my/7/2.png" @click="stepChange(6)"/>
    </div>
    <div name="my" class="my" v-else-if="step === 8">
        <!-- 계정정보 -->
        <img class="image" src="../../assets/showcase/xi/my/8/1.png" @click="stepChange(0)"/>
        <img class="image" src="../../assets/showcase/xi/my/8/2.png"/>
    </div>
</template>

<script>
export default {
    data: function()
    {
        return {
            step: 0
        }
    },
    props: ['selectedStep'],
    mounted: function()
    {
        this.step = this.selectedStep;
    },
    methods: {
        goHistory: function()
        {
            this.$emit('goHistory')
        },
        goHistoryHospital: function()
        {
            this.$emit('goHistoryHospital')
        },
        reset: function()
        {
            this.$emit('resetCount')
        },
        stepChange: function(step)
        {
            this.step = step;
            this.reset();
        }
    }
}
</script>

<style scoped>
    .my {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
    }
    .image {
        width: 100%;
    }
    .wrapper {
        position: relative;
        width: 100%;
    }
    .button1 {
        position: absolute;
        width: 33%;
        aspect-ratio: 1;
        top: 0;
        left: 0;
        z-index: 1;
    }
     .button2 {
        position: absolute;
        width: 33%;
        aspect-ratio: 1;
        top: 0;
        left: 33%;
        z-index: 1;
    }
     .button3 {
        position: absolute;
        width: 33%;
        aspect-ratio: 1;
        top: 0;
        left: 66%;
        z-index: 1;
    }
    .bottom {
        bottom: calc((100vw - 8vw) * 120 / 375);
        position: fixed; 
        width: calc(100% - 12.4px - 8vw);
    }
    .bottom2 {
        bottom: calc((100vw) * 120 / 375);
        position: fixed; 
        width: calc(100% - 12.4px - 7vw);
    }
</style>


// WEBPACK FOOTER //
// src/components/showcase/My.vue